import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiX } = FiIcons;

const SearchFilters = ({ manufacturers, categories, onFilterChange, currentFilters }) => {
  const handleFilterUpdate = (key, value) => {
    const newFilters = { ...currentFilters };
    if (value) {
      newFilters[key] = value;
    } else {
      delete newFilters[key];
    }
    onFilterChange(newFilters);
  };

  return (
    <motion.div
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6"
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Filter</h3>
        <button
          onClick={() => onFilterChange({})}
          className="text-sm text-red-600 hover:text-red-700 font-medium"
        >
          Alle Filter zurücksetzen
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Category Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Kategorie
          </label>
          <select
            value={currentFilters.category || ''}
            onChange={(e) => handleFilterUpdate('category', e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500"
          >
            <option value="">Alle Kategorien</option>
            {categories.map(category => (
              <option key={category.code} value={category.code}>
                {category.name} ({category.count})
              </option>
            ))}
          </select>
        </div>

        {/* Manufacturer Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Hersteller
          </label>
          <select
            value={currentFilters.manufacturer || ''}
            onChange={(e) => handleFilterUpdate('manufacturer', e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500"
          >
            <option value="">Alle Hersteller</option>
            {manufacturers.map(manufacturer => (
              <option key={manufacturer} value={manufacturer}>
                {manufacturer}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Advanced Filters */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="font-medium text-gray-900 mb-3">Erweiterte Filter</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="flex items-center">
            <input
              id="in-stock"
              type="checkbox"
              checked={currentFilters.inStock || false}
              className="rounded border-gray-300 text-red-600 focus:ring-red-500"
              onChange={(e) => handleFilterUpdate('inStock', e.target.checked || undefined)}
            />
            <label htmlFor="in-stock" className="ml-2 text-sm text-gray-700">
              Nur verfügbare Artikel
            </label>
          </div>
          
          <div className="flex items-center">
            <input
              id="stainless"
              type="checkbox"
              checked={currentFilters.stainless || false}
              className="rounded border-gray-300 text-red-600 focus:ring-red-500"
              onChange={(e) => handleFilterUpdate('stainless', e.target.checked || undefined)}
            />
            <label htmlFor="stainless" className="ml-2 text-sm text-gray-700">
              Edelstahl
            </label>
          </div>
          
          <div className="flex items-center">
            <input
              id="sealed"
              type="checkbox"
              checked={currentFilters.sealed || false}
              className="rounded border-gray-300 text-red-600 focus:ring-red-500"
              onChange={(e) => handleFilterUpdate('sealed', e.target.checked || undefined)}
            />
            <label htmlFor="sealed" className="ml-2 text-sm text-gray-700">
              Mit Dichtung
            </label>
          </div>
          
          <div className="flex items-center">
            <input
              id="high-temp"
              type="checkbox"
              checked={currentFilters.highTemp || false}
              className="rounded border-gray-300 text-red-600 focus:ring-red-500"
              onChange={(e) => handleFilterUpdate('highTemp', e.target.checked || undefined)}
            />
            <label htmlFor="high-temp" className="ml-2 text-sm text-gray-700">
              Hochtemperatur
            </label>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SearchFilters;